import { observer } from "mobx-react";
import { RadioButton } from "../../../../../components/inputs/radio-button/radio-button";
import "./plan-type-layout.scss";


interface IProps {
    radioButtonName: string;
    isChecked?: boolean;
    onChange?: () => void;
    children: React.ReactChild|React.ReactNode;
}

const PlanTypeLayout: React.FC<IProps> = observer(({children, radioButtonName, isChecked, onChange}: IProps) => {

    return(
        <div className="plan-type-layout" onClick={onChange}>
            {children}
            <div className="plan-type-radio-button">
                <RadioButton 
                    name={radioButtonName}
                    checked={isChecked}
                />
            </div>
        </div>
    )
});

export default PlanTypeLayout;